<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/south-africa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/south-africa/constantia/restless-river')">Restless River</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/south-africa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Costantia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'ultima delle tre importanti regioni produttrici di vino in Sud Africa è Constantia, situata nei sobborghi di Città del Capo. Meno conosciuta dei suoi due vicini superstar, Constantia è la regione vinicola più antica del Sud Africa e meglio conosciuta in passato per il suo leggendario Vin de Constance. La sua popolarità aumentò nel XVIII secolo quando fu menzionata sia da Jane Austen che da Charles Dickens e divenne rapidamente il vin de choix di re e imperatori in Europa. Al giorno d'oggi Constantia ha raggiunto lo stile moderno della vinificazione e se stai cercando un Sauvignon Blanc superlativo e dal clima fresco, allora non puoi davvero sbagliare con un Constantia.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Constantia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Das letzte der drei wichtigsten Weinanbaugebiete Südafrikas ist Constantia, am Fuße von Kapstadt gelegen. Constantia ist weniger bekannt als seine beiden Superstar-Nachbarn und die älteste Weinregion Südafrikas. In der Vergangenheit war sie vor allem für ihren legendären Vin de Constance bekannt. Seine Beliebtheit stieg im 18. Jahrhundert, als Jane Austen und Charles Dickens ihn erwähnten, und er wurde schnell zum Lieblingswein der Könige und Kaiser in Europa. Heutzutage hat Constantia mit dem modernen Stil der Weinherstellung Schritt gehalten, und wenn Sie auf der Suche nach einem Sauvignon Blanc der Superlative mit kühlem Klima sind, können Sie mit einem Constantia nichts falsch machen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Constantia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La dernière des trois régions viticoles importantes d'Afrique du Sud est Constantia, située dans les sous-sols de Cape Town. Moins connue que ses deux voisines superstars, Constantia est la plus ancienne région viticole d'Afrique du Sud, et surtout connue dans le passé pour son légendaire Vin de Constance. Sa popularité a explosé au XVIIIe siècle lorsqu'il a été mentionné à la fois par Jane Austen et Charles Dickens et est rapidement devenu le vin de choix des rois et des empereurs d'Europe. De nos jours, Constantia a rattrapé le style moderne de vinification et si vous recherchez un sauvignon blanc superlatif de climat frais, vous ne pouvez pas vraiment vous tromper avec un Constantia.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Constantia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        The final of the three important wine producing regions in South Africa is Constantia, located in the suberns of Cape Town. Less well-known than its two superstar neighbours, Constantia is South Africa’ oldest wine region, and best known in the past for its legendary Vin de Constance. Its popularity surged in the 18th century when it was mentioned by both Jane Austen and Charles Dickens and quickly became le vin de choix of kings and emperors in Europe. Nowadays Constantia has caught up with the modern style of winemaking and if you&#39;re looking for superlative, cool-climate Sauvignon Blanc then you can’t really go wrong with a Constantia.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Constantia",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Restless River', src: '/wine-guide/south-africa/constantia/restless-river'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Constantia fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich history and diverse flavors of Constantia, one of South Africa\'s oldest wine regions. Experience the unique blend of traditional and modern winemaking techniques at renowned Constantia wine producers.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
